
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/customization/headless",
      function () {
        return require("private-next-pages/x/react-chat/customization/headless.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/customization/headless"])
      });
    }
  